import { withCloseAfterExited } from "@10duke/dukeui";
import {
  default as View,
  UnsuspendUserModalProps
} from "./unsuspend-user-modal-view";

const UnsuspendUserModal = withCloseAfterExited<UnsuspendUserModalProps>(View);
export default UnsuspendUserModal;
